import { getCruiseCatalog } from '../data/dummyCatalog';

function norm(s = '') {
  return s.toLowerCase().replace(/[^a-z0-9]/g, '');
}

function matchText(haystack, needle) {
  if (!needle) return true;
  const n = norm(needle);
  return norm(haystack).includes(n);
}

function searchCatalog(items, params, fields, limit = 80) {
  const q = params.port || params.keyword || '';
  const n = norm(q);
  const scored = items
    .map((item) => {
      if (!q) return { item, score: 1 };
      let score = 0;
      fields.forEach((f) => {
        const v = norm(String(item[f] || ''));
        if (v === n) score += 10;
        else if (v.includes(n)) score += 5;
        else if (n.includes(v) && v.length > 3) score += 2;
      });
      return { item, score };
    })
    .filter(({ score: s }) => s > 0 || !q);

  if (!scored.length) return items.slice(0, limit);
  scored.sort((a, b) => b.score - a.score);
  return scored.slice(0, limit).map(({ item }) => item);
}

export function searchCruisesFromCatalog(params, limit = 80) {
  const items = getCruiseCatalog();
  const port = params.port || '';
  const dest = params.destination || '';

  let results = items.filter((c) => {
    const portOk = !port || matchText(c.port, port) || matchText(c.portSlug, port);
    const destOk = !dest || matchText(c.destination, dest) || matchText(c.regionSlug, dest);
    return portOk && destOk;
  });

  if (results.length < 10) {
    results = searchCatalog(items, { port }, ['port', 'portSlug', 'destination'], limit);
  }
  if (results.length < 10) results = items.slice(0, limit);

  return results.slice(0, limit);
}
